//CSS
import '../../Components/Page/Page.css'
import './ElfPower.css';
import slide29 from '../../Images/Slides/90aSlide29.png'
import SlideComp from '../../Components/SlideComp/SlideComp';

//React
import React from 'react';
import SecHeader from '../../Components/SecHeader/SecHeader';


const ElfPower: React.FC = () => {
    return (
        <div id="Goals">
            <SecHeader title="The Power of Elf-Techs Geometry" />

            <SlideComp source={slide29} />
        </div>
    );
};

export default ElfPower;